// @ts-nocheck
import {FreeMovie} from '../factory/FreeMovie.js';
export {};
angular
  .module('moviePool')
  .directive('onsdFreeMovies', [
    'PimpMyRide',
    (PimpMyRide) => PimpMyRide('Movies', false, () => FreeMovie.pastMovies()),
  ]);
